"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transferReceiverUserNames = void 0;
var _reselect = require("reselect");
var _arrayHelper = require("../../helpers/arrayHelper");
var transferReceiverUserNames = exports.transferReceiverUserNames = (0, _reselect.createSelector)(function (state) {
  return state.transfer.transfers;
}, function (transfers) {
  return (0, _arrayHelper.distinct)(transfers.map(function (transfer) {
    return transfer.ReceiverUserName;
  }));
});